"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmplifyServerContextError = void 0;
var AmplifyServerContextError_1 = require("./AmplifyServerContextError");
Object.defineProperty(exports, "AmplifyServerContextError", { enumerable: true, get: function () { return AmplifyServerContextError_1.AmplifyServerContextError; } });
